'use strict'

import React from 'react'
import { Link } from 'react-router'
import IndexList from './IndexListComponent'
import Pager from './PagerComponent';
import Loading from './LoadingComponent';
import $ from 'jquery'
import qs from 'qs'

require('styles/Index.less')

let config = require('config');

let indexCloseSVG        = require('../images/index_close.svg')
var indexCloseStyle      = { backgroundImage:'url(' + indexCloseSVG + ')' }

let mobileHamburgerSVG   = require('../images/mobile_hamburger.svg')
var mobileHamburgerStyle = { backgroundImage:'url(' + mobileHamburgerSVG + ')' }

var logoGray;
if (config.default.THEME == "B") {
  logoGray = require('../images/logo.png')
} else {
  logoGray = require('../images/logo_gray.png')
}

class Index extends React.Component
{
  constructor(props) {
    super(props)
    this.state = {
      isClickedOpen:false,
      isSideAppear:false,
      isOpenIndex:false,
      catId:null
    }
    this.indexOpen        = this.indexOpen.bind(this);
    this.indexClose       = this.indexClose.bind(this)
    this.selectIndexClose = this.selectIndexClose.bind(this)
    this.selectCat        = this.selectCat.bind(this)
    this.event()
  }
  componentDidMount() {
    const { actions, data } = this.props

    if (location.search) {
      var query = location.search.split("?")[1]
      var obj = qs.parse(query);
      if (obj["cat"] == undefined && obj["page"]) {
        var num = parseInt(obj["page"])
        actions.setCurrentIndex(num)
        actions.getTotalIndexPage();
        actions.getIndexPosts(num);
      } else {
        if (obj["cat"] == undefined && obj["page"] == undefined) {
          actions.getTotalIndexPage();
          actions.getIndexPosts(1);
        } else {
          this.getQueryData()
        }
      }
    } else {
      actions.getTotalIndexPage();
      actions.getIndexPosts(1);
    }

    $(window).scrollTop(0)
    if (config.default.THEME == "B") {
      this.resize()
      if (data.singlePost) {
        this.setState({
          isSideAppear:true,
          isOpenIndex:true
        })
      }
    }
  }
  event() {
    var self = this
    $(document).on("click", "#index .pager_container a", function() {
      var id = parseInt($(this).data("page"))
      self.updateIndexPage(id)
      return false
    })
    if (config.default.THEME == "B") {
      $(window).on("resize", function() {
        self.resize()
      })
      self.resize()
    }
  }
  resize() {
    var max = 0
    $(".indexlist ul li .info").css({ "min-height":0 })
    $(".indexlist ul li").each(function() {
      var h = $(this).find(".info").outerHeight()
      max = Math.max(h, max)
    })
    $(".indexlist ul li .info").css({ "min-height":max })
    if ($(window).width() < 769) {
      $(".indexlist ul li .info").css({ "min-height":0 })
    }
  }
  updateIndexPage(num) {
    const { actions, data } = this.props
    if (num != data.currentIndexPage) {
      actions.setCurrentIndex(num)
      if (data.selectCat) {
        actions.getIndexPostsByCat(num, data.selectCat)
      } else {
        actions.getIndexPosts(num)
      }
      $(window).scrollTop(0)
    }
  }
  selectCat(e) {
    const { actions, data } = this.props;
    var id = $(e.target).data('id')

    $('.index .cats li a').removeClass('current')
    $(e.target).addClass('current')
    actions.setCurrentIndex(1)
    if (id) {
      actions.getTotalIndexPage(id)
      actions.getIndexPostsByCat(1, id)
    } else {
      actions.getTotalIndexPage()
      actions.getIndexPosts(1)
    }
  }
  indexOpen() {
    this.setState({
      isClickedOpen:true,
      isSideAppear:true,
      isOpenIndex:true
    })
  }
  indexClose() {
    const { actions, data } = this.props;
    if (config.default.THEME == "B") {
      if (!data.singlePost) {
        if ($(window).width() < 640) {
          this.setState({
            isClickedOpen:false,
            isSideAppear:false,
            isOpenIndex:false
          })
          return
        }
      }
    }
    actions.indexClose()
    setTimeout(function() { $(window).scrollTop(data.scrollTop) }, 1)
  }
  selectIndexClose() {
    const { actions } = this.props;
    actions.indexClose()
    $(window).scrollTop(0)
  }
  componentDidUpdate() {
    if (config.default.THEME == "B") {
      const { actions, data } = this.props;
      if (location.search) {
        this.getQueryData()
      } else {
        if (this.state.catId != null) {
          this.setState({ catId:null })
          actions.getTotalIndexPage()
          actions.getIndexPosts(1)
        }
      }
      this.resize()

      if (this.state.catId == null) {
        $('.index .cats li a').removeClass('current')
        $('.index .cats li:first-child a').addClass('current')
      } else {
        $('.index .cats li a').removeClass('current')
        $('.index .cats li a[data-id="' + this.state.catId + '"]').addClass('current')
      }
    }
  }
  getQueryData() {
    const { actions, data } = this.props;
    var query = location.search.split("?")[1]
    var obj = qs.parse(query);
    if (obj["cat"]) {
      var id = obj["cat"]
      var num = obj["page"]
      if (this.state.catId != id) {
        this.setState({ catId:id })
        actions.getTotalIndexPage(id)
        if (!num) num = 1
        actions.getIndexPostsByCat(num, id)
      }
    }
  }
  getCateogrySlugById(id) {
    const { data } = this.props;
    var result = "";
    if (data.categories != null) {
      for(var i = 0; i < data.categories.length; i++) {
        if (id == data.categories[i].id) {
          result = data.categories[i].slug;
        }
      }
    }
    return result;
  }
  render() {
    const { actions, data, params } = this.props;
    var self = this
    if (data.categories == null || data.indexPages == null) {
      return (<div/>)
    }
    var indexPostsNum = null
    if (data.indexPosts) {
      indexPostsNum = data.indexPosts.length
    }
    var isClose = true
    if (config.default.THEME == "B") {
      if (!data.singlePost) {
        if ($(window).width() < 640) {
          isClose = false
        } else {
          isClose = false
        }
      }
      if (this.state.isClickedOpen) {
        isClose = true
      }
      this.resize()
    }

    // is loading
    var isListLoading = true
    if (config.default.THEME == "B") {
      if (data.indexPosts != null && ((data.lastIndexPath == "/?cat="+this.state.catId) || (data.lastIndexPath == "/" && this.state.catId == null))) {
        isListLoading = false
      }
    } else {
      if (data.indexPosts != null) {
        isListLoading = false
      }
    }

    return (
      <div className='index'>
        <div className='header'>
          { isClose ?
            <a className="close" onClick={this.indexClose}><span style={indexCloseStyle}></span></a>
          :null }
          { !this.state.isOpenIndex ?
            <a className='open mobile' onClick={this.indexOpen}><span style={mobileHamburgerStyle}></span></a>
          :null }
          { config.default.THEME == "B" ?
            <h1><img src={logoGray} alt={config.default.SITE_NAME}/></h1>
          :
            <div className='logo'><img src={logoGray} alt={config.default.SITE_NAME} /></div>
          }
        </div>
        <div className='inner'>
          <div className={'side ' + (indexPostsNum == 0 ? 'no_float ':'') + (this.state.isSideAppear ? 'appear':'') }>
            <ul className='cats'>
              <li><Link to='/' onClick={this.selectCat} className={isListLoading ? 'current disabled':'current'}>All</Link></li>
              { data.categories ?
                data.categories.map(function(cat, i)
                {
                  if (config.default.THEME == "B") {
                    return (
                      <li key={i}><Link to={'/?cat='+cat.slug} onClick={self.selectCat} data-id={cat.slug} className={isListLoading ? 'disabled':''}>{ cat.name }</Link></li>
                    )
                  } else {
                    return (
                      <li key={i}><a onClick={self.selectCat} data-id={cat.id}>{ cat.name }</a></li>
                    )
                  }
                })
              :null }
            </ul>
            <ul className='pages'>
              { data.indexPages ?
                data.indexPages.map(function(page, i)
                {
                  if (page.acf.url)
                  {
                    var slug = page.acf.url.split("/")[3]
                    return (
                      <li key={i}><Link to={'/' + slug} onClick={self.selectIndexClose}>{ page.title.rendered }</Link></li>
                    )
                  }
                  else if (page.acf.blank_link_url)
                  {
                    return (
                      <li key={i}><a href={page.acf.blank_link_url} target="_blank">{ page.title.rendered }</a></li>
                    )
                  }
                })
              :null }
            </ul>
          </div>
          <div className='main'>
            { !isListLoading ?
              <div className='list'>
                <IndexList posts={data.indexPosts} cat={data.categories} actions={actions} />
              </div>
            :
              <Loading cl={"index"} />
            }
            { !isListLoading ?
              <Pager type='index' actions={actions} totalpage={data.totalIndexPage} current={data.currentIndexPage} num={data.currentIndexPage} cat={data.selectCat} />
            :null }
          </div>
        </div>
        <footer className='ifooter'><div className='inner'>
          <p>system by <a href='http://everythingbuttheinternet.com/' target='_blank'>everything but the internet</a></p>
        </div></footer>
      </div>
    )
  }
}

Index.displayName = 'Index'

Index.propTypes = {}
Index.defaultProps = {}

export default Index



// WEBPACK FOOTER //
// ./src/components/IndexComponent.js